import { apiClient, setAccessToken } from "./client";

export async function login({ email, senha }) {
  const data = await apiClient.post("/auth/login", { email, senha });
  setAccessToken(data.accessToken);
  return data;
}

export async function refresh() {
  const data = await apiClient.post("/auth/refresh");
  setAccessToken(data.accessToken);
  return data;
}

export async function logout() {
  try {
    await apiClient.post("/auth/logout");
  } finally {
    setAccessToken(null);
    localStorage.removeItem("usuario");
    // Reseta os avisos adiados ("me lembre depois") para reaparecerem ao logar
    // de novo na plataforma.
    sessionStorage.removeItem("avisos_destaque_adiados");
  }
}

export function getUsuarioAtual() {
  return apiClient.get("/usuarios/me");
}
